import { api } from '@System/api';

export default {
    getOnBoarding: () => api.get('/merchant/onboardings', {singleRequest: true, loading: false }),
    getDashboard: (params) => api.get('/merchant/onboardings/stats', {params, singleRequest: true, loading: false})
};
